export * from '@va/svg-visa-icons';
export * from './ai-icons';
export * from './browser-icons';
export * from './device-icons';
export * from './gradient-icons';
export * from './lock-icons';
export * from './misc';
export * from './operating-systems-icons';

export type IconProps = {
  className?: string;
  color?: string;
};
